import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useNavigation } from '@navigation';
import { useServiceError } from '@store';

interface ServiceErrorResources {
	message: string;
	button: string;
}

interface ServiceErrorOutput {
	resources: ServiceErrorResources;
	onClickHandler: () => void;
}

export const useServiceErrorHelper = (): ServiceErrorOutput => {
	const { gotoHome } = useNavigation();
	const t = useTranslation();
	const serviceError = useServiceError();

	const resources = {
		message: serviceError?.message || '',
		button: t('general.back'),
	};

	const onClickHandler = () => {
		gotoHome();
	};

	return {
		resources,
		onClickHandler,
	};
};
